import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Texas.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Mobile App Development in Texas?</h2>
            <p>
              Choose TekRevol’s mobile app development Services in Texas, where
              innovation ignites with local excellence to offer tailored
              solutions for your business triumph. We have a well-established
              record of delivering high-quality mobile applications that have
              received praise and success in the industry. Our experts
              specialize in crafting customized mobile application solutions
              that line up with your business objectives, & yield 100% customer
              satisfaction. TekRevol is at the forefront of emerging mobile
              technological trends, leveraging the latest tools and frameworks
              to make innovative apps. Our agile development strategies
              guarantee faster results, rapid iterations, and adaptability to
              accommodate changing demands.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
